import React from 'react';
import { Subtitle } from "../shared/components/subtitle/subtitle";
import './projects.css'

export const Projects = () => {
    return (
        <div id="projects" className="projects-section py-8">
            <div className="container"> 
                <div className="projects-card-image">
                    <div className="eu-logo-wrapper">
                        <img src="/images/eu-projects/eu-flag-1.jpg" alt="eu logo" width={'250px'}/>
                    </div>
                    <div>
                        <Subtitle subtitle="EU projekti"/>
                        <p>
                            AP-Metal koristi EU fondove za ulaganje u novu opremu i tehnologiju, što omogućuje bržu proizvodnju i veću preciznost u obradi metala. Time se unapređuje poslovanje i postižu međunarodni standardi kvalitete i sigurnosti.
                        </p>
                    </div>
                </div>
                <div className="projects-card mt-4">
                    <div className="content-wrapper">
                        <div className="projects-card-content">
                            <h3 className="projects-intro">
                            Naziv projekta: Inovativna naprava za ubrzanu proizvodnju - NPOO.C1.1.2.R2-I4.01.0085 <br/>
                                Korisnik: AP-Metal, obrt za strojnu obradu metala, vl. Antonio Pastor<br/>
                                Vrijednost projekta: 25.000,00 €<br/>
                                Maksimalni iznos bespovratnih sredstava: 25.000,00 €<br/>
                                Razdoblje provedbe projekta: 07.12.2024. – 07.06.2026.<br/>
                            </h3>

                            <div className="projects-note">
                                <p>
                                    Trenutne metode stezanja u CNC proizvodnji predstavljaju značajan tehnološki i ekonomski problem. Postojeći sustavi zahtijevaju višestruko ručno podešavanje i nuliranje, što prema industrijskim istraživanjima smanjuje ukupnu produktivnost za čak 30%, a stopu grešaka povećava za do 20%. Uz to, složenost rukovanja CNC strojevima otežava uključivanje manje iskusnih operatera, što povećava ovisnost o stručnom kadru i dodatno podiže troškove rada.
                                    Cilj ovog projekta je razviti i implementirati inovativnu pomoćnu napravu za CNC strojeve koja omogućava precizno stezanje s mogućnošću rotacije od 360°.<br/> Naprava je osmišljena kako bi u potpunosti eliminirala potrebu za višestrukim nuliranjima i ručnim podešavanjima, čime se značajno ubrzava i pojednostavljuje proizvodni proces.
                                    <br/>Ključni rezultati koje projekt želi postići su:
                                </p>
                                <ul>
                                    <li>Povećanje efikasnosti proizvodnje za 50%</li>
                                    <li>Osiguravanje iznimne preciznosti do 0,005 mikrona</li>
                                    <li>Sigurniji i automatiziraniji rad operatera</li>
                                    <li>Smanjenje ukupnih troškova proizvodnje kroz optimizaciju vremena i resursa</li>
                                    <li>Omogućavanje rada manje iskusnim operaterima, smanjujući potrebu za stručnom intervencijom</li>
                                </ul>
                                <p>
                                    Implementacija ovog rješenja imat će poseban značaj za mala i srednja poduzeća u metaloprerađivačkoj industriji, koja će dobiti pristup tehnologiji koja povećava njihovu konkurentnost na globalnom tržištu. Osim toga, projekt je usmjeren i prema obrazovnim ustanovama te tehničkim institutima, čime se dugoročno doprinosi razvoju stručnih kompetencija u industriji.
                                    Ukupno gledano, ovaj projekt predstavlja konkretno i mjerljivo rješenje za unapređenje CNC proizvodnje, spajajući tehničku inovaciju s praktičnim ekonomskim i sigurnosnim prednostima za sve sudionike u industrijskom procesu.
                                </p>
                                 <div>
                            <h4>KONTAKT</h4>
                            <p>
                                AP-Metal, obrt za strojnu obradu metala, vl. Antonio Pastor, Dragutina Žanića-Karle 16, 32100 Vinkovci
                            </p>
                            <p>
                                Telefon:+385994358662<br/>
                                E-mail: apmetal24@gmail.com
                            </p>
                            <p>
                                Za pomoć u pripremi projektnog prijedloga te provedbi projekta zaduženo je društvo Tehnološki park Vinkovci d.o.o. Više informacija o društvu možete pronaći na internetskoj stranici www.tp-vk.hr
                            </p>
                        </div>
                            </div>
                        </div>
                    </div>
                    <div className="projects-card-image d-flex flex-column align-items-center justify-content-center">
                        <div className="eu-logo-wrapper">
                            <img src="/images/eu-projects/eu-nextgen.jpg" alt="eu logo" width={'100%'}/>
                        </div>
                        <p className="text-center mt-4">
                            Korisne poveznice<br/>
                            <a href="https://fondovieu.gov.hr/" target="_blank" rel="noopener noreferrer">
                                https://fondovieu.gov.hr/
                            </a>
                        </p>
                       
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Projects;
